import { FC } from 'react'
import { useWindowSize } from 'react-use'
import { getStyledBrandsContainer } from '../../styled-components/HomeSection.styled'
import { MD_SCREEN } from '../../util/screen-size'
import { BwebIcon } from '../icons/BwebIcon.component'
import { EntrepreneurIcon } from '../icons/EntrepreneurIcon.component'
import { FortuneIcon } from '../icons/FortuneIcon.component'
import { MashableIcon } from '../icons/MashableIcon.component'
import { MicrosoftIcon } from '../icons/MicrosoftIcon.component'

export interface BrandsContainerProps {

}

export const BrandsContainer: FC<BrandsContainerProps> = (props) => {
    
    const { width } = useWindowSize();
    const size = width > MD_SCREEN

    const height = !size ? 20 : undefined
    const comWidth = !size ? 90 : undefined
    const bwebWidth = !size ? 60 : undefined


    const StyledBrandsContainer = getStyledBrandsContainer()

    return (
        <StyledBrandsContainer>
            <div className='title'>Trusted by over 1k+ companies</div>
            <div className='logo-container'>
                <MicrosoftIcon height={height} width={comWidth} />
                <EntrepreneurIcon height={height} width={comWidth} />
                <FortuneIcon height={height} width={comWidth} />
                <BwebIcon height={height} width={bwebWidth} />
                <MashableIcon height={height} width={comWidth} />
            </div>
        </StyledBrandsContainer>
    )
}